/* eslint-disable react-hooks/exhaustive-deps */
// @ts-nocheck
import React, { cache, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useGlobalContext } from "../../../Services/PaginationGlobal";
import MMCTransactionList from "../../../screen/MMC/MMCTransactionList";
import MMCSuspendedList from "../../../screen/MMC/MMCSuspendedList";
import MMCCancellationList from "../../../screen/MMC/MMCCancellationList";
import { checkPermission } from "../../../screen/redux/api/PermissionManager";
import { post } from "../../../Services/ApiHandler";
import { URLS } from "../../../Services/Constant";
import { toast } from "react-toastify";

const OverallMMC = () => {
  const location = useLocation();
  const property_id = location?.state?.id;
  const property_name = location?.state?.property_name;
  const owner_name = location?.state?.owner_name;
  const owner_code = location?.state?.owner_code;
  const navigate = useNavigate();
  const path = location.pathname?.replace("/", "");
  const { paginationData, setpaginationData } = useGlobalContext();
  const [tabs, setTabs] = useState(
    (paginationData?.[path]?.mmcTabs ??
      checkPermission("CAN-LIST-MMC_TRANSACTION"))
      ? 1
      : checkPermission("CAN-LIST-MMC_SUSPENDED")
        ? 2
        : 3,
  );

  // New state for confirmation modal
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setpaginationData((prev) => ({
      ...prev,
      [path]: { ...prev?.[path], mmcTabs: tabs },
    }));
  }, [tabs]);

  // Show confirmation modal
  const handleCancelClick = () => {
    setShowConfirmModal(true);
  };

  // Confirm cancellation
  const handleConfirmCancel = async () => {
    setIsLoading(true);
    try {
      const res = await post(`${URLS.CANCEL_MMC}${property_id}/`);
      console.log("mmccancelres", res);
      if (res?.status === "success") {
        setShowConfirmModal(false);
        navigate("/mmc-cancellation-list", { state: { tab: 2 } });
        toast.success(res?.message);
      }
    } catch (err) {
      toast.error(err?.message || "Failed to cancel MMC");
    } finally {
      setIsLoading(false);
    }
  };

  // Close modal without canceling
  const handleCloseModal = () => {
    setShowConfirmModal(false);
  };

  return (
    <div>
      <div
        className="d-flex gap-4 mt-4"
        style={{
          justifyContent: "space-between",
          alignItems: "center",
          paddingRight: 200,
        }}
      >
        <div className="d-flex ac-js gap-4 ">
          {checkPermission("CAN-LIST-MMC_TRANSACTION") && (
            <p
              onClick={() => setTabs(1)}
              className={`${
                tabs === 1 ? "prim-btn" : "sec"
              } f4 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 pointer`}
            >
              {" "}
              Transaction
            </p>
          )}
          {checkPermission("CAN-LIST-MMC_SUSPENDED") && (
            <p
              onClick={() => setTabs(2)}
              className={`${
                tabs === 2 ? "prim-btn" : "sec"
              } f4 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16  ms-4 pointer`}
            >
              Suspended
            </p>
          )}
          {checkPermission("CAN-LIST-MMC_CANCELLATION") && (
            <p
              onClick={() => setTabs(3)}
              className={`${
                tabs === 3 ? "prim-btn" : "sec"
              } f4 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16  ms-4 pointer`}
            >
              Cancellation
            </p>
          )}
        </div>
        <div className="prim-btn" onClick={handleCancelClick}>
          <p style={{ fontSize: 18 }}>Cancel MMC</p>
        </div>
      </div>

      {/* Confirmation Modal */}
      {showConfirmModal && (
        <div className="modal-overlay" style={styles.overlay}>
          <div className="modal-content" style={styles.modal}>
            <h3 style={styles.title}>Confirm Cancellation</h3>
            <p style={styles.message}>Are you sure you want to Cancel MMC?</p>
            <div style={styles.buttonGroup}>
              <button
                onClick={handleCloseModal}
                style={styles.cancelButton}
                disabled={isLoading}
              >
                No
              </button>
              <button
                onClick={handleConfirmCancel}
                style={styles.confirmButton}
                disabled={isLoading}
              >
                {isLoading ? "Canceling..." : "Yes"}
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="d-flex gap-3 mb-3">
        <div className="roles-bg  rounded-4">
          <h2 className=" f4 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18">
            Property Name: {property_name}
          </h2>
          <h2 className=" f4 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 ">
            Property ID: {property_id}
          </h2>
        </div>
        <div className="roles-bg  rounded-4 mb-3">
          <h2 className=" f4 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18">
            Owner Name: {owner_name}
          </h2>
          <h2 className=" f4 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 ">
            Owner ID: {owner_code}
          </h2>
        </div>
      </div>
      {tabs === 1 && <MMCTransactionList property_id={property_id} />}
      {tabs === 2 && <MMCSuspendedList property_id={property_id} />}
      {tabs === 3 && <MMCCancellationList property_id={property_id} />}
    </div>
  );
};

// Inline styles for modal
const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",

    zIndex: 1000,
    // flexdric,
    // widhth: 20,
  },
  modal: {
    backgroundColor: "white",
    borderRadius: "8px",
    padding: "30px",
    minWidth: "350px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    textAlign: "center",
    width: "80px",
  },
  title: {
    fontSize: "20px",
    fontWeight: "600",
    marginBottom: "15px",
    color: "#333",
  },
  message: {
    fontSize: "16px",
    color: "#666",
    marginBottom: "25px",
    lineHeight: "1.5",
  },
  buttonGroup: {
    display: "flex",
    gap: "12px",
    justifyContent: "center",
  },
  cancelButton: {
    padding: "10px 25px",
    fontSize: "14px",
    fontWeight: "500",
    border: "1px solid #ddd",
    borderRadius: "4px",
    backgroundColor: "#f5f5f5",
    cursor: "pointer",
    transition: "all 0.3s",
  },
  confirmButton: {
    padding: "10px 25px",
    fontSize: "14px",
    fontWeight: "500",
    border: "none",
    borderRadius: "4px",
    backgroundColor: "#dc3545",
    color: "white",
    cursor: "pointer",
    transition: "all 0.3s",
  },
};

export default OverallMMC;
